import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../../../../components/modal'

const CommissionDetailModal = ({
    isOpen,
    onClose,
    commission,
    agentName,
    t,
    formatCurrency,
    formatDate
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={t('AGENT_COMMISSIONS_COMMISSION_DETAIL_TITLE')}
            subtitle={agentName}
            icon="zmdi-file-text"
            size="medium"
            className="commission-detail-modal"
        >
            <div className="detail-modal-content">
                <div className="detail-summary">
                    <div className="summary-main">
                        <span className="summary-label">{t('AGENT_COMMISSIONS_TABLE_AMOUNT')}</span>
                        <span className="summary-value">
                            {formatCurrency(commission?.commissionAmount || commission?.amount, commission?.currency)}
                        </span>
                    </div>
                    <div className="summary-meta">
                        <span className="meta-chip">
                            <i className="zmdi zmdi-calendar"></i>
                            {formatDate(commission?.applicationDate || commission?.createdAt)}
                        </span>
                        <span className="meta-chip">
                            <i className="zmdi zmdi-chart"></i>
                            {commission?.commissionRate || '-'}%
                        </span>
                        <span className={`meta-chip status-chip status-${commission?.status || commission?.applicationStatus || 'unknown'}`}>
                            <i className="zmdi zmdi-info-outline"></i>
                            {commission?.status || commission?.applicationStatus || '-'}
                        </span>
                    </div>
                </div>

                <div className="detail-section-card">
                    <h6 className="detail-section-title">
                        <i className="zmdi zmdi-account"></i>
                        {t('AGENT_COMMISSIONS_TABLE_STUDENT')}
                    </h6>
                    <div className="detail-grid compact">
                        <div className="detail-item">
                            <span className="detail-label">{t('AGENT_COMMISSIONS_TABLE_STUDENT')}</span>
                            <span className="detail-value">
                                {(() => {
                                    const student = commission?.student || commission?.application?.student || {}
                                    const name = `${student.firstName || ''} ${student.lastName || ''}`.trim()
                                    return name || student.user?.email || '-'
                                })()}
                            </span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">{t('AGENT_COMMISSIONS_TABLE_STATUS')}</span>
                            <span className="detail-value">{commission?.applicationStatus || commission?.status || '-'}</span>
                        </div>
                    </div>
                </div>

                <div className="detail-section-card">
                    <h6 className="detail-section-title">
                        <i className="zmdi zmdi-graduation-cap"></i>
                        {t('AGENT_COMMISSIONS_TABLE_PROGRAM')}
                    </h6>
                    <div className="detail-grid">
                        <div className="detail-item full">
                            <span className="detail-label">{t('AGENT_COMMISSIONS_TABLE_PROGRAM')}</span>
                            <span className="detail-value">{commission?.program?.name || commission?.application?.program?.name || '-'}</span>
                        </div>
                        <div className="detail-item full">
                            <span className="detail-label">{t('AGENT_COMMISSIONS_TABLE_UNIVERSITY')}</span>
                            <span className="detail-value">{commission?.program?.university?.name || commission?.application?.program?.university?.name || '-'}</span>
                        </div>
                    </div>
                </div>

                <div className="detail-section-card">
                    <h6 className="detail-section-title">
                        <i className="zmdi zmdi-comment-text"></i>
                        {t('AGENT_COMMISSIONS_TABLE_NOTES')}
                    </h6>
                    <div className="detail-grid">
                        <div className="detail-item full">
                            <span className="detail-label">{t('AGENT_COMMISSIONS_TABLE_NOTES')}</span>
                            <span className="detail-value">{commission?.notes || commission?.decisionNotes || '-'}</span>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

CommissionDetailModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    commission: PropTypes.object,
    agentName: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    formatCurrency: PropTypes.func.isRequired,
    formatDate: PropTypes.func.isRequired
}

export default CommissionDetailModal

